import { StyledGridColumnProps } from '@components/Grid/Grid.model';
import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const EbookLayout = styled.div<{ bgImg: any }>`
  padding: 64px 0;
width: 100%:
height : fit-content;
  
  ${({ bgImg }) =>
    bgImg &&
    `
    background-image: url(${bgImg});
    background-size: cover;            
    background-repeat: no-repeat;      
    background-position: center;      
  `}

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY}{
  padding : 64px 0 ;
  }
`;

export const EbookLeftTextBox = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  justify-content: start;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    justify-content: center;
  }
`;

export const EbookRightImageBox = styled.div`
  flex: 1 1 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
`;

export const EbookResponsiveImage = styled.img`
  max-height: 350px;
  width: auto;
  height: auto;
  max-width: 100%;
  object-fit: contain;
`;

export const EbookButton = styled.div`
  padding : 16px 32px;
  background-color : #fff;

  border-radius : 12px;
  align-items : center;
  justify-content;
  width : fit-content;

  &:hover {
    cursor: pointer;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    
    align-items: center;
    justify-content : center;
    width : 100%;
  }

`;

export const EbookSection = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  align-items: center;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
`;
